<template>
  <ContentSection>
    <div
      class="w-full rounded-bl-lg border border-red-500 transition-colors"
      :class="open
        ? 'bg-red-500 pb-4 duration-75'
        : 'duration-300'"
    >
      <button
        type="button"
        class="
          flex w-full items-center justify-between py-1 pl-3 pr-1 text-left
          font-semibold transition-colors
          md:py-0
        "
        :class="open
          ? 'bg-red-500 text-black duration-75'
          : 'text-red-500 duration-300'"
        @click="open = !open"
      >
        {{ data.heading }}
        <PlusMinus
          :is-minus="open"
          color-minus="black"
        />
      </button>
      <div
        ref="collapseRef"
        class="
          px-3 text-white
          [&_a]:text-black
        "
      >
        <TextWithContent :content="data.text_with_content" />
      </div>
    </div>
  </ContentSection>
</template>

<script setup lang="ts">
import type { MainComponentsCollapseFragment } from '#gql'

defineProps<{ data: Enforce<MainComponentsCollapseFragment> }>()

const collapseRef = ref<HTMLElement | undefined>(undefined)

const options = {
  duration: 300,
  initiallyClosed: true,
}

const open = useCollapse(collapseRef, options)
</script>
